const GA_THEME = {
  isDesktopProductGallery() {
    return window.matchMedia("(min-width: 769px)").matches;
  },

  lazyLoadVideo(video) {
    if (!video) return;
    let needsLoad = false;
    video.querySelectorAll("source[data-src]").forEach((s) => {
      s.src = s.dataset.src;
      s.removeAttribute("data-src");
      needsLoad = true;
    });
    if (video.dataset.src && !video.src) {
      video.src = video.dataset.src;
      video.removeAttribute("data-src");
      needsLoad = true;
    }
    if (needsLoad) {
      video.load();
    }
  },

  normalizeProductGallery(swiper) {
    if (!swiper) return;

    if (swiper.wrapperEl) swiper.wrapperEl.style.removeProperty("height");
    if (swiper.el) swiper.el.style.removeProperty("height");

    if (swiper.params.loop) {
      const index =
        typeof swiper.realIndex === "number"
          ? swiper.realIndex
          : swiper.activeIndex;

      swiper.params.loop = false;

      if (swiper.loopedSlides && typeof swiper.loopDestroy === "function") {
        swiper.loopDestroy();
      }

      swiper.update();
      swiper.slideTo(index, 0);
    }

    swiper.slideTo(swiper.activeIndex, 0);
    swiper.updateSize();
    swiper.updateSlides();
  },

  initProductSwiper(selector) {
    const swiperEl = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!swiperEl) return;
    swiperEl.classList.add("swiper-ready");

    const { thumbId } = swiperEl.dataset;
    const thumbEl = document.querySelector(`#swiper-thumb-${thumbId}`);

    if (swiperEl.swiper) {
      GA_THEME.normalizeProductGallery(swiperEl.swiper);
      const thumbSwiper = thumbEl && thumbEl.swiper;
      if (thumbSwiper && window.innerWidth > 768) {
        thumbSwiper.slideTo(swiperEl.swiper.activeIndex, 0);
      }
      if (window.innerWidth <= 768 && thumbEl) {
        const wrapper = thumbEl.querySelector('.swiper-wrapper');
        const activeThumb = thumbEl.querySelectorAll('.pdt-slide')[swiperEl.swiper.activeIndex];
        if (wrapper && activeThumb) {
          const scrollTarget = activeThumb.offsetLeft - (wrapper.clientWidth - activeThumb.clientWidth) / 2;
          wrapper.scrollTo({ left: Math.max(0, scrollTarget), behavior: 'smooth' });
        }
      }
      return;
    }

    const swiperThumb = thumbEl
      ? new Swiper(thumbEl, {
          spaceBetween: 6,
          slidesPerView: 3,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          direction: "horizontal",
          allowTouchMove: false,
          breakpoints: {
            769: {
              direction: "vertical",
              slidesPerView: "auto",
              allowTouchMove: true,
            },
          },
        })
      : null;

    const mainSwiper = new Swiper(swiperEl, {
      loop: false,
      rewind: false,
      autoHeight: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      centeredSlides: false,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      thumbs: swiperThumb
        ? {
            swiper: swiperThumb,
            slideThumbOnClick: true,
          }
        : undefined,
      breakpoints: {
        769: {
          allowSlideNext: true,
          allowSlidePrev: true,
        },
      },
      on: {
        init(swiper) {
          GA_THEME.normalizeProductGallery(swiper);
          swiperEl
            .querySelectorAll(".product__modal-opener .product__media img")
            .forEach((img) => {
              if (img.complete) return;
              img.addEventListener(
                "load",
                () => GA_THEME.normalizeProductGallery(swiper),
                { once: true }
              );
            });
        },
        slideChange(swiper) {
          swiperEl.querySelectorAll("video.product-gallery-video, video.variant-gallery-video").forEach((v) => v.pause());
          const activeSlide = swiper.slides[swiper.activeIndex];
          if (activeSlide) {
            const video = activeSlide.querySelector("video.product-gallery-video, video.variant-gallery-video");
            if (video) {
              GA_THEME.lazyLoadVideo(video);
              video.currentTime = 0;
              video.play().catch(function () {});
            }
          }
          if (thumbEl) {
            const slides = thumbEl.querySelectorAll(".pdt-slide");
            slides.forEach((s, i) => {
              if (i === swiper.activeIndex) {
                s.classList.add("swiper-slide-thumb-active");
              } else {
                s.classList.remove("swiper-slide-thumb-active");
              }
            });
            if (window.innerWidth <= 768) {
              const wrapper = thumbEl.querySelector(".swiper-wrapper");
              const activeThumb = slides[swiper.activeIndex];
              if (wrapper && activeThumb) {
                const scrollTarget = activeThumb.offsetLeft - (wrapper.clientWidth - activeThumb.clientWidth) / 2;
                wrapper.scrollTo({ left: Math.max(0, scrollTarget), behavior: "smooth" });
              }
            }
          }
        },
        slideChangeTransitionEnd(swiper) {
          swiper.updateSize();
        },
        resize(swiper) {
          GA_THEME.normalizeProductGallery(swiper);
        },
      },
    });

    const navNext = swiperEl.querySelector(".swiper-button-next");
    const navPrev = swiperEl.querySelector(".swiper-button-prev");
    if (navNext) {
      navNext.addEventListener("click", function () {
        mainSwiper.slideNext();
      });
    }
    if (navPrev) {
      navPrev.addEventListener("click", function () {
        mainSwiper.slidePrev();
      });
    }

    if (thumbEl) {
      thumbEl.querySelectorAll(".swiper-slide").forEach((slide, idx) => {
        slide.addEventListener("click", () => {
          const targetSlide = mainSwiper.slides[idx];
          if (targetSlide) {
            const vid = targetSlide.querySelector("video");
            if (vid) GA_THEME.lazyLoadVideo(vid);
          }
          mainSwiper.slideTo(idx);
          if (swiperThumb && window.innerWidth > 768) {
            swiperThumb.slideTo(idx);
          }
          if (window.innerWidth <= 768) {
            const wrapper = thumbEl.querySelector(".swiper-wrapper");
            if (wrapper) {
              const scrollTarget = slide.offsetLeft - (wrapper.clientWidth - slide.clientWidth) / 2;
              wrapper.scrollTo({ left: Math.max(0, scrollTarget), behavior: "smooth" });
            }
          }
        });
      });
    }

    window.addEventListener(
      "resize",
      () => {
        GA_THEME.normalizeProductGallery(mainSwiper);
        if (swiperThumb) {
          if (window.innerWidth <= 768) {
            swiperThumb.allowTouchMove = false;
            if (swiperThumb.params) swiperThumb.params.allowTouchMove = false;
          } else {
            swiperThumb.allowTouchMove = true;
            if (swiperThumb.params) swiperThumb.params.allowTouchMove = true;
          }
          swiperThumb.update();
        }
      },
      { passive: true }
    );
  },
};

function initSwiperDeferred() {
  if (window.__swiperInitialized) return;
  window.__swiperInitialized = true;
  document.querySelectorAll(".product-media-gallery").forEach((el) => el.classList.add("swiper-ready"));
  GA_THEME.initProductSwiper(".js-product-media-gallery");

  document.querySelectorAll(".product__modal-opener").forEach((opener) => {
    opener.addEventListener("click", () => {
      const modalId = opener.getAttribute("data-modal");
      if (modalId) {
        const modal = document.querySelector(modalId);
        if (modal) {
          modal.querySelectorAll("video").forEach((v) => GA_THEME.lazyLoadVideo(v));
        }
      }
    });
  });
}

["touchstart", "pointerdown", "click", "scroll", "touchmove", "mousemove", "mouseenter"].forEach((evt) => {
  window.addEventListener(evt, initSwiperDeferred, { once: true, passive: true });
});

window.addEventListener("load", () => {
  setTimeout(initSwiperDeferred, 4000);
});

const GA = {
  aslider: function () {
    $("#a-slider").slick({
      slidesToShow: 1,
      arrows: false,
      dots: false,
      loop: true,
      autoplay: true,
      pauseOnHover: false,
      fade: false,
      pauseOnFoucus: false,
      autoplaySpeed: 4000,
    });
  },
  productMessage: function () {
    let checkbox = document.getElementById("ga-message-checkbox");
    if (checkbox) {
      checkbox.addEventListener("change", function () {
        if (checkbox.checked) {
          document.getElementById("message").style.display = "block";
        } else {
          document.getElementById("message").style.display = "none";
          document.getElementById("message").value = "";
        }
      });
    }
  },
  setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie =
      name + "=" + encodeURIComponent(value) + expires + "; path=/";
  },
  getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURIComponent(cookie.substring(nameEQ.length));
      }
    }
    return null;
  },
  popup: function () {
    // Check if popup was already shown before
    let hasShown = GA.getCookie("ga_show_popup");

    // Do NOT show popup on contact form pages
    if (
      window.location.href.includes("customer_posted=true#contact_form") ||
      window.location.href.includes("form_type=customer#contact_form")
    ) {
      $(".popup").fadeOut();
      GA.setCookie("ga_show_popup", "true", 30); // store as shown
      return;
    }

    // If popup has already been shown once → do nothing
    if (hasShown === "true") {
      return;
    }

    // Show popup after 45 seconds (only first visit)
    setTimeout(function () {
      $(".popup").fadeIn();
      GA.setCookie("ga_show_popup", "true", 1); // mark as shown for 30 days
    }, 45000);

    // When popup is closed → hide it and mark as shown permanently
    $(".popup-close").on("click", function () {
      $(".popup").fadeOut();
      GA.setCookie("ga_show_popup", "true", 1);
    });
  },
  slideshow: function () {
    const el = document.querySelector(".ga-slideshow");
    if (!el || el.classList.contains("slick-initialized")) return;
    $(".ga-slideshow").slick({
      slidesToShow: 1,
      arrows: false,
      dots: true,
      loop: true,
      autoplay: true,
      pauseOnHover: false,
      fade: true,
      pauseOnFoucus: false,
      autoplaySpeed: 4000,
    });
  },

  hideHomeLogo: function () {
    if (document.body) {
      document.body.classList.add("ga-show-logo");
    }
  },
  testimonials: function () {
    const el = document.querySelector(".ga-testimonials-slider");
    if (!el) return;
    $(".ga-testimonials-slider").each(function () {
      const $slider = $(this);
      if ($slider.hasClass("slick-initialized")) return;
      const $wrap = $slider.closest(".ga-tesimonials-wrap");
      $slider.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        autoplaySpeed: 4000,
        prevArrow: $wrap.find(".ga-tn-prev").length ? $wrap.find(".ga-tn-prev") : ".ga-tn-prev",
        nextArrow: $wrap.find(".ga-tn-next").length ? $wrap.find(".ga-tn-next") : ".ga-tn-next",
        responsive: [
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
  },

  //hide discount price for Cosmic Eyes Kajal Trio

  init: function () {
    const run = () => {
      GA.hideHomeLogo();
      GA.popup();
      GA.productMessage();
      if (typeof GA.putReviewsInLogo === "function") {
        GA.putReviewsInLogo();
      }
      GA.slideshow();
      GA.testimonials();
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", run);
    } else {
      run();
    }
    window.addEventListener("load", run);
    document.addEventListener("shopify:section:load", run);
  },
};
GA.init();
